<script setup lang="ts">
import { t } from "../i18n";
import Icon from "./Icon.vue";
const model = defineModel<string>({ default: "" });
withDefaults(defineProps<{ placeholder?: string; label?: string }>(), {
  placeholder: "",
});
</script>
<template>
  <label class="search-field"
    ><Icon name="search" :size="19" /><input
      v-model="model"
      :placeholder="placeholder || t('common.search')"
      :aria-label="label || placeholder || t('common.search')" /><button
      v-if="model"
      type="button"
      class="icon-button"
      aria-label="Limpar pesquisa"
      @click="model = ''"
    >
      <Icon name="close" :size="18" /></button
  ></label>
</template>
